module.exports = __webpack_public_path__ + "static/media/logo.c48c0394.svg";